/**
 * The content seed as the views read it — typeset once, at export.
 *
 * Home, about, industries, resources and the overlays render
 * `@mb-group/content-seed` directly (industries, pillars, lead magnets have no
 * gateway query). They import it from here, never from the package, so the
 * seed gets the same hard spaces as gateway content (data/typography.ts).
 * The DEMO projection (data/demo.ts) keeps the raw seed: its output is typeset
 * by the gateway.
 */
import type { Locale } from "@mb-group/shared-types";
import { contentSeed as rawSeed, type ContentSeed } from "@mb-group/content-seed";
import { typesetContent } from "./typography.js";

const SEEDS: Record<Locale, ContentSeed> = {
	pl: typesetContent(rawSeed("pl"), "pl"),
	en: typesetContent(rawSeed("en"), "en"),
};

/** The typeset content seed for a locale (falls back to PL, like the package). */
export function contentSeed(locale: Locale): ContentSeed {
	return SEEDS[locale] ?? SEEDS.pl;
}
